<template>
  <div :class="{ container: !isReport }">
    <BarLineChart v-if="loaded" :chartdata="chartdata" :options="options" />
  </div>
</template>

<script>
import BarLineChart from "@/components/BarLineChart";

export default {
  name: "BarLineChartContainer",
  components: { BarLineChart },
  data: () => ({
    loaded: false,
    chartdata: null,
    options: null,
  }),
  props: {
    data: {
      type: Object,
      default: null,
    },
    showPercent: {
      default: true,
    },
    hideLegend: {
      type: Boolean,
      default: false,
    },
    isReport: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    data: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.loaded = false;

          let { secCol, logoCol } = this.$store.getters;

          let { data, label, barColor } = newValue;

          try {
            this.chartdata = {
              labels: Object.keys(data),
              datasets: [
                {
                  type: "line",
                  label: label,
                  borderColor: secCol,
                  data: Object.values(data),
                  fill: false,
                  pointRadius: 30,
                  pointHoverRadius: 30,
                  pointBackgroundColor: logoCol,
                  pointBorderColor: logoCol,
                  datalabels: {
                    color: "white",
                    backgroundColor: "transparent",
                    borderRadius: 50,
                    font: {
                      size: 25,
                      family: "Barlow Condensed",
                    },
                    formatter: value => {
                      return value + (this.showPercent ? "%" : "");
                    },
                  },
                },
                {
                  type: "bar",
                  label: label,
                  data: Object.values(data),
                  backgroundColor: Array(Object.values(data).length).fill(
                    barColor
                  ),
                  barPercentage: 0.1,
                  datalabels: {
                    color: "transparent",
                  },
                },
              ],
            };
          } catch {
            // console.error(e);
          }

          this.loaded = true;
        }
      },
    },
  },
  async mounted() {
    this.loaded = false;

    let { secCol, logoCol } = this.$store.getters;

    let { data, label, barColor } = this.data;

    try {
      //   const { userlist } = await fetch("/api/userlist");

      this.chartdata = {
        labels: Object.keys(data),
        datasets: [
          {
            type: "line",
            label: label,
            borderColor: secCol,
            data: Object.values(data),
            fill: false,
            pointRadius: 30,
            pointHoverRadius: 30,
            pointBackgroundColor: logoCol,
            pointBorderColor: logoCol,
            datalabels: {
              color: "white",
              backgroundColor: "transparent",
              borderRadius: 50,
              font: {
                size: 25,
                family: "Barlow Condensed",
              },
              formatter: value => {
                return value + (this.showPercent ? "%" : "");
              },
            },
          },
          {
            type: "bar",
            label: label,
            data: Object.values(data),
            backgroundColor: Array(Object.values(data).length).fill(barColor),
            barPercentage: 0.1,
            datalabels: {
              color: "transparent",
            },
          },
        ],
      };

      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: this.hideLegend
          ? null
          : {
              onClick: () => {},
            },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0,
                suggestedMax: 100,
                callback(value) {
                  return value + (this.showPercent ? "%" : "");
                },
              },
            },
          ],
        },
      };
    } catch {
      // console.error(e);
    }

    this.loaded = true;
  },
};
</script>
